<template>
  <div class="md-layout">
    <div id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{list.pageIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color">{{ $route.name }} </h1>
        <h2 style="visibility: hidden;opacity:0;"></h2>
      </div>
    </div>

    <ElasticList :list="list" :filter="filter" :exclude="exclude" ref="casesList"></ElasticList>
  </div>
</template>

<script>
  import ElasticList from "@/components/DynamicForm/ElasticList";
  import Page from '@/mixins/Page';

  export default {
    components: {
      ElasticList
    },
    mixins: [Page],
    data() {
      return {
        list: {
          hideListHeader: true,
          editPath: "cases",
          pageTitle: "Cases",
          pageIcon: "how_to_vote",
          listQueryId: "searchCaseCustoms",
          responseFieldName: "searchCases",
          linkRows: true,
          mustNotFilter: [{ term: { status: 'merged' } }],
          addonFilters: [
            {
              id: 'caseTeamId',
              query: 'listTeams',
              key: 'id',
              label: 'name',
              placeholder: 'Filter Teams',
              modal: '',
              value: '',
              all: {
                isEnabled: true,
                label: 'All Teams',
              },
              default: {
                key: 'name',
                value: 'Atlas',
              }
            },
            {
              id: 'caseUserId',
              query: 'listUsers',
              key: 'id',
              label: 'name',
              placeholder: 'Filter Assignee',
              modal: '',
              value: '',
              labelFormatter: (item) => {
                let name = '';
                if (item && item.given_name && item.family_name) {
                  name = `${item.given_name} ${item.family_name}`;
                }
                return name;
              },
              unassigned: {
                isEnabled: true,
                label: 'Unassigned',
                key: 'caseUserId'
              },
              default: {
                key: 'name',
                value: '',
              }
            },            
            {
              id: 'status',
              query: 'listCaseStatusEnum',
              queryOptionsKey: 'enumValues',
              key: 'name',
              label: 'name',
              placeholder: 'Status',
              modal: '',
              value: '',
            },            
          ],
          deleteQueryId: "deleteCase",
          deleteMessageNameFields: ['subject'],
          columns: {
            subject: { label: "Subject", sortable: true },
            person: { label: "Person", sortable: false, searchable: true, display: true, nested: ["given_name", "family_name"] },
            quickNote: { label: "Quick Note", sortable: true },
            priority: { label: "Priority", sortable: true },
            createdAt: { label: "Created", sortable: true, dateFilter: true},
            closedDate: { label: "Closed", sortable: true, dateFilter: true},
            status: { label: "Status", sortable: true },
            user: { label: "Assignee", sortable: false, display: true, nested: ["given_name", "family_name"]  },
            team: { label: "Team", sortable: false, searchable: true, display: true, nested: ["name"] },
            type: { label: "Type", sortable: false, searchable: true},
            service: { label: "Service", sortable: false },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];
              if (data && data.searchCases && data.searchCases.items.length) {
                
                data.searchCases.items.forEach((item) => {
                  item.quickNote = item.quickNote ? item.quickNote.substring(0, 30) : '';
                  if(item.services && item.services.items && item.services.items.length) {
                    item.service = item.services.items[0] ? item.services.items[0].service.name : '';
                  }
                  //remove _ in type
                  if (typeof item.type !== 'undefined' && item.type) {
                    item.type = item.type.replace(/_/g, ' ');
                  }
                  //remove _ in status
                  if(item.status) {
                    item.status = item.status.replace(/_/g, ' ');
                  }
                  result.push(item);
                })
              }
            return result;
          }
        },
        exclude: {},
        filter: [],
      };
    },
    beforeMount() {
      // if url search query is found then clear addon filter
      if (this.$route.query.q) {
        this.list.addonFilters[0].default = {};
      }
      this.generateFilters();
    },
    mounted() {
      this.$router.metaData = null
    },
    methods: {
      /**
       * Clear addon filters and search
       * @returns {Void}
       */
      clearAddonFilterAndSearch() {
        // if reference is not found then bail
        if (!this.$refs.casesList || !this.$refs.casesList.$el) {
          return;
        }
        // get clear addon filters button
        const eleAddonFiltersRemoveButton = this.$refs.casesList.$el.querySelector('._addonFilters .md-button');
        // clear addon filters
        if (eleAddonFiltersRemoveButton) {
          eleAddonFiltersRemoveButton.click();
        }
      },
      generateFilters() {
        if (this.$Session.isInternalGroupMember) {
          this.filter = [];
          this.exclude = {};
          return;
        }
        this.filter = [ 
          { term: { internal: false } }
        ];
        this.exclude = {
          must_not: [
            { term: { internal: true } },
            { term: { status: 'merged' } }
          ]
        };
      }
    },
    watch: {
      '$Session.isInternalGroupMember': {
        immediate: true,
        handler: function() {
          this.generateFilters();
        },
      },
      '$route.query.q': {
        immediate: true,
        handler: function() {
          // when global search query is changed - clear addon filters and search
          if(this.$route.query.q) {
            this.clearAddonFilterAndSearch();
          }
        },
      },
    }
  };
</script>

<style></style>
